import { useEffect } from 'react';
import { User } from './common/types';
import { RES_TYPES, useFetch } from './hooks/useFetch';
import React from 'react';
import { useAuth, useAutoSignin } from "react-oidc-context";
import { useRoleContext } from './roleProvider';

export const Profile = () => {
  const { data } = useFetch<User | undefined>('/api/user/me', {
    method: 'GET',
    lateFetch: false,
    resType: RES_TYPES.json,
    defaultValue: undefined,
  });
  const { isLoading, isAuthenticated } = useAutoSignin({signinMethod: "signinRedirect"});
  const auth = useAuth();
  const { setRoles } = useRoleContext();

  useEffect(() => {
    if (data) {
      setRoles(data.roles.map(row => row.name));
    } else {
      setRoles([]);
    }
  }, [data, setRoles]);

  useEffect(() => {
    if(!auth.isAuthenticated) {
      setRoles([]);
    }
  }, [auth.isAuthenticated]);

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      auth.signinRedirect();
    }
  }, [isLoading, isAuthenticated]);

  if (auth.isLoading) {
    return <span>Loading</span>;
  }

  return (
  <>
  </>
  );
};
